import { render, staticRenderFns } from "./RankingPage.vue?vue&type=template&id=558e847c&scoped=true"
import script from "./RankingPage.vue?vue&type=script&lang=ts"
export * from "./RankingPage.vue?vue&type=script&lang=ts"
import style0 from "./RankingPage.vue?vue&type=style&index=0&id=558e847c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e847c",
  null
  
)

export default component.exports